import {
  VuexModule,
  Module,
  Action,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "./index";
import { RecaptchaService } from "@/services/storage.service";
import authModule from "@/store/auth.module";
export type SnackBarColor = "success" | "warning" | "error";
interface SnackBarPayload {
  show?: boolean;
  message: string;
  color?: SnackBarColor;
  timeout?: number;
}

interface NavigationItem {
  to?: string;
  globalTo?: string;
  href?: string;
  text: string;
  children?: NavigationItem[];
}

@Module({ namespaced: true, dynamic: true, store, name: "base" })
class BaseModule extends VuexModule {
  snackBarPayload: SnackBarPayload = {
    show: false,
    message: "",
    color: "success",
    timeout: -1,
  };
  recaptchaV2FailDate = RecaptchaService.getV2FailDate();
  showHeader = true;
  showNavigation = true;
  navigation = false;
  progress = false;

  get navigationItems() {
    return [
      {
        href: "/",
        text: "Main",
      },
      {
        href: "/debtors",
        text: "DebtorsRegistry",
      },
      {
        href: "/news",
        text: "News",
      },
      {
        text: "Для граждан",
        children: [
          {
            href: "/forCitizens/ratingLawmen",
            text: "LawmenRating",
          },
          {
            href: "/forCitizens/departments",
            text: "LawmenDepartments",
          },
          {
            href: "/forCitizens/recomendedLawmen",
            text: "RecomendedLawmen",
          },
          {
            href: "https://www.gov.kz/memleket/entities/adilet/about/structure/105/1",
            text: "Контакты ДЮ",
          },
          {
            href: "/forCitizens/findArest",
            text: "FindArest",
          },
          {
            href: "https://zhso.kz/index.php?view=catalog&main_cat=2&cat_id=12",
            text: "Контакты РПЧСИ",
          },
          {
            globalTo: "/statements",
            text: "Подача заявления ЧСИ",
          },
          {
            href: "/forCitizens/calc",
            text: "Calc",
          },
        ],
      },
      {
        text: "Documents",
        children: [
          {
            href: "/documents/check",
            text: "CheckDocument",
          },
          {
            href: "/documents/findEP",
            text: "FindEP",
          },
        ],
      },
      {
        href: "https://etp.adilet.gov.kz/",
        text: "Торговая площадка",
      },
      {
        to: "/",
        text: this.defaultName,
        children: [],
      },
    ];
  }

  get defaultName() {
    if (authModule.isEmployer) return "Работодатель";
    if (authModule.isClaimant) return "Взыскатель";
    return "Cabinet";
  }

  get blockRECAPTCHA() {
    return (
      !!localStorage.getItem("blockRECAPTCHA") ||
      !!process.env.VUE_APP_BLOCK_RECAPTCHA
    );
  }

  get defaultRoute() {
    if (authModule.isEmployer) return "/requests";
    if (authModule.isClaimant) return "/claimant-analytics";
    else return "/mail";
  }

  @Mutation
  private setSnackBarPayload(snackBarPayload: SnackBarPayload) {
    this.snackBarPayload = snackBarPayload;
  }
  @Mutation
  public setRecaptchaFailDate() {
    RecaptchaService.setV2FailDate();
    this.recaptchaV2FailDate = RecaptchaService.getV2FailDate();
  }

  @Mutation
  public switchNavigation(value: boolean) {
    this.navigation = value;
  }

  @Mutation
  public setShowHeader(value: boolean) {
    this.showHeader = value;
  }

  @Mutation
  public setShowNavigation(value: boolean) {
    this.showNavigation = value;
  }

  @Mutation
  public setProgress(progress: boolean) {
    this.progress = progress;
  }

  @Action
  public async showMessage({
    message,
    color = "success",
    timeout = 6000,
  }: SnackBarPayload) {
    this.setSnackBarPayload({
      message,
      color,
      timeout,
      show: true,
    });
  }
}

export default getModule(BaseModule);
